import * as React from 'react';
import * as IoC from 'typescript-ioc';
import classnames from 'classnames';
import { isSameDay } from 'date-fns';
import * as mobxReact from 'mobx-react';
import { DateFnsFormats } from '../../../../../infrastructure/date-formatter';
import { DateTimeFormatter } from '../../../../../infrastructure/implementations/date-formatter';
import { getFormattedTimezoneOffset, utcToZonedTime } from '../../../../../infrastructure/utils/date-fns-overrides.utils';
import './list-day-item.scss';
import { getIsSafariBrowser } from '../../../../../infrastructure/utils/common.utils';
import { GroupCollapseIcon } from '../../../../global/group-collapse-icon/group-collapse-icon';


const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);

const ListDayTimeItem = mobxReact.observer((props: {
    startDateTime: Date;
    endDateTime: Date;
    eventTimezone: string;
    colSpan: number;
    isCollapsed?: boolean;
    onCollapseToggle?: () => void;
    withCollapse?: boolean;
    isAllMeetingsCollapsed?: boolean;
    groupHeaderRef?: React.RefObject<HTMLElement>;
    title: string;
}) => {
    const {
        startDateTime,
        endDateTime,
        eventTimezone,
        colSpan,
        isCollapsed,
        isAllMeetingsCollapsed,
        onCollapseToggle,
        withCollapse,
        groupHeaderRef,
        title
    } = props;

    const dayStringInEventTimezone = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        DateFnsFormats.StringifiedFullDayMonthNumericDateYear,
        eventTimezone
    );

    const startTime = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        dateTimeFormatter.getLocalTimeFormat()
    );

    const endTime = dateTimeFormatter.dateToFormattedString(
        endDateTime,
        dateTimeFormatter.getLocalTimeFormat()
    );

    const startTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        dateTimeFormatter.getLocalTimeFormat(),
        eventTimezone
    );

    const endTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(
        endDateTime,
        dateTimeFormatter.getLocalTimeFormat(),
        eventTimezone
    );

    const isEventTimezoneTimeDifferents = startTimeInEventTimezone !== startTime;
    const timeZoneOffset = getFormattedTimezoneOffset(startDateTime);

    const localDayString = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        DateFnsFormats.StringifiedFullDayMonthNumericDateYear,
    );

    const isSafari = getIsSafariBrowser();

    return (
        <tr className={classnames('list-day-time-item', { 'list-day-time-item--with-status': title })}
            onClick={onCollapseToggle}
            ref={groupHeaderRef as React.RefObject<HTMLTableRowElement>}
        >
            <th colSpan={colSpan} className={classnames('single-row-title-cell date-cell',
                { 'single-row-title-cell--safari-browser': isSafari }
                )}
            >
                {withCollapse && (
                    <GroupCollapseIcon isCollapsed={isCollapsed} isAllItemsCollapsed={isAllMeetingsCollapsed} />
                )}
                <div className='list-day-time-item__content'>
                    <span className='table-list-layout__inline-title'>{dayStringInEventTimezone}</span>
                    <span className='meeting-list-item__header meeting-list-item__header--date-and-time'>
                        {startTimeInEventTimezone} - {endTimeInEventTimezone}
                    </span>
                    {!isSameDay(startDateTime, utcToZonedTime(startDateTime, eventTimezone)) &&
                        <span className='meeting-list-item__text meeting-list-item__text--small
                            meeting-list-item__text--date-and-time'
                            data-testid='local-day'
                        >
                            {localDayString}
                        </span>
                    }
                    { isEventTimezoneTimeDifferents &&
                        <span className='meeting-list-item__text meeting-list-item__text--small
                            meeting-list-item__text--date-and-time'
                            data-testid='local-time'>
                            {startTime} - {endTime} ({timeZoneOffset})
                        </span>
                    }
                    { title && (
                        <div className='list-day-time-item__meeting-status'>
                            Status: <span>{ title }</span>
                        </div>
                    )}
                </div>
            </th>
        </tr>
    );
});

export { ListDayTimeItem };
